<div class="heading-section">
  <div class="title">
    <h2 class="item-text">Countdown to the end of round</h2>
  </div>
</div>

<div class="wg-countdown">
  <span class="js-countdown style-2">
    <div aria-hidden="true" class="countdown__timer">
      <span class="countdown__item">
        <span class="countdown__value countdown__value--0 js-countdown__value--0">{{ days }}</span>
      </span>
      <span class="countdown__item">
        <span class="countdown__value countdown__value--1 js-countdown__value--1">{{ hours }}</span>
      </span>
      <span class="countdown__item">
        <span class="countdown__value countdown__value--2 js-countdown__value--2">{{ minutes }}</span>
      </span>
      <span class="countdown__item">
        <span class="countdown__value countdown__value--3 js-countdown__value--3">{{ seconds }}</span>
      </span>
    </div>
  </span>
</div>
